module.exports = __webpack_public_path__ + "media/images/eyedropper-icon-0f732dd61c4a31a407529bff5fe79a1c.png";